import { render, staticRenderFns } from "./Jrecommendations.vue?vue&type=template&id=7cdc091b"
import script from "./Jrecommendations.vue?vue&type=script&lang=js"
export * from "./Jrecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports